import { useMutation } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

export type BaseLocationRequest = {
  LspId: number;
};

export type GetAssociatedTagCampaignsPayload = {
  TagId: number;
};

export type AssociatedTagCampaign = {
  MarketingCampaignId: number;
  TagId: number;
};

export type GetAssociatedTagCampaignsResult = AssociatedTagCampaign[];

export function useGetAssociatedTagCampaignsMutation() {
  return useMutation({
    mutationFn: async (tagId: number) =>
      fetchData<GetAssociatedTagCampaignsResult>('api/marketing-campaign/get-associated-tag-campaigns', {
        TagId: tagId,
      }),
  });
}
